import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import apiService from "../../../api/api.service";

import {
  setI18nSettings,
  setSettings,
  setTimeZone,
} from "../../../store/settings";
import { setI18n } from "../../../store/i18n";
import { setAssets } from "../../../store/assets";

import Theme from "./ThemeSpecial";
import FooterLinks from "../../FooterLinks";
import Loading from "../../../common/loading";
import "../../../scss/theme_special/index_special.scss";
import Style from "style-it";
import ToastApp from "../../common/ToastApp";

function ThemeSpecial({ shop }) {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.ui);
  const {
    additional: additionalSettings,
    general: generalSettings,
    progressBar: progressSettings,
    additional,
  } = useSelector((state) => state.settings);
  const mainColor = generalSettings?.mainColor;
  const order = useSelector((state) => state.order);
  const [firstLoad, setFirstLoad] = useState(true);

  useEffect(() => {
    const getTimeZoneBrowser = async () => {
      const response = await apiService.get("getTimeZoneBrowser", {
        shop: shop,
      });
      if (response.status === 200) {
        dispatch(setTimeZone(response?.data?.time_zone));
      }
    };
    getTimeZoneBrowser();
  }, [shop, dispatch]);

  useEffect(() => {
    const getSettings = async () => {
      const response = await apiService.getTrackingPageMutation({
        shop: shop,
      });
      setFirstLoad(false);
      if (response?.data?.state === 1) {
        dispatch(setSettings(response?.data?.settings));
        dispatch(setAssets(response?.data?.assets));
        dispatch(setI18nSettings(response?.data?.i18n));
        dispatch(setI18n(response?.data?.i18n));
        return;
      }
    };
    if (shop) {
      getSettings();
    }
  }, [shop]);

  const markup = (
    <div
      className="omg-app"
      style={{
        width: `${generalSettings.width + (100 - generalSettings.width) / 2}%`,
      }}
    >
      <div className="omg-main-content">
        {additional.textAbove && (
          <div
            className="text-above"
            dangerouslySetInnerHTML={{ __html: additional.textAbove }}
          ></div>
        )}
        {additionalSettings.htmlTop && (
          <div
            className="html-top"
            dangerouslySetInnerHTML={{ __html: additionalSettings.htmlTop }}
          ></div>
        )}
        <div className="omg-layout">
          <div className="omg-section">
            <Theme order={order} shop={shop} />
            {isLoading && <Loading type={8} />}
          </div>
        </div>

        {additionalSettings.textBelow && (
          <div
            className="text-below"
            dangerouslySetInnerHTML={{ __html: additionalSettings.textBelow }}
          ></div>
        )}

        {additionalSettings.htmlBottom && (
          <div
            className="html-bottom"
            dangerouslySetInnerHTML={{
              __html: additionalSettings.htmlBottom,
            }}
          ></div>
        )}
      </div>
      <FooterLinks />
      <ToastApp />
    </div>
  );

  const customCss = `
    .omg-app {
      --progress-color: ${mainColor};
      --button-track-color: ${generalSettings.buttonColor};
      --color-text: ${generalSettings.textColor};
      --button-border-radius: ${generalSettings.buttonBorder}px;
      --button-track-text-color: ${generalSettings.buttonTextColor};
      --resize-app: ${
        shop === "beverly-hills-best-deals.myshopify.com" ? 100 : 62.5
      }
    }
    ${additionalSettings.customCss}
  `;

  return firstLoad ? <Loading type={8}></Loading> : Style.it(customCss, markup);
}

export default ThemeSpecial;
